import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: {},
    },
    loading: false,
  },
  mutations: {
    changeLoginState(state, user) {
      if (user) {
        state.user = {
          loggedIn: true,
          data: user,
        };
      } else {
        state.user = {
          loggedIn: false,
          data: {},
        };
      }
    },
    setLoading(state) {
      state.loading = true;
    },
    setNotLoading(state) {
      state.loading = false;
    },
  },
  actions: {},
  modules: {},
});
